import { NavLink  } from 'react-router-dom';
import "./Logo.css";
import icon from '../../static/images/icona_stagingpower.png';
import logo from '../../static/images/logo_stagingpower.png';

export default function LogoMenu({ onClick, isClicked, isMode }) {

  	return (
  	    <div className={`app-brand ${isClicked ? "" : "change-icon"}`} >
            <NavLink to="/home" className="app-brand-link">
                <span className="app-brand-logo">
                    <img src={isClicked ? logo : icon} className="img-fluid" alt="Login image"/>
                </span>
            </NavLink>
            <a onClick={onClick} className="layout-menu-toggle menu-link text-large ms-auto cursor-pointer">
                <i className="bx bx-chevron-left bx-sm d-flex align-items-center justify-content-center"></i>
            </a>
        </div>
	);
}